var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNota(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.012,
    height: 15.006,
    viewBox: "0 0 15.012 15.006",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "nota",
    transform: "translate(-1.1 -1.105)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1490",
    "data-name": "Caminho 1490",
    d: "M7.231,9.923h8.385a.453.453,0,1,0,0-.907H7.231a.453.453,0,1,0,0,.907Z",
    transform: "translate(-2.818 -3.926)",
    fill: "#7d0000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1491",
    "data-name": "Caminho 1491",
    d: "M7.231,16.007h8.385a.453.453,0,0,0,0-.907H7.231a.453.453,0,1,0,0,.907Z",
    transform: "translate(-2.818 -6.945)",
    fill: "#7d0000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1492",
    "data-name": "Caminho 1492",
    d: "M10.862,21.184H7.231a.453.453,0,1,0,0,.907h3.631a.453.453,0,1,0,0-.907Z",
    transform: "translate(-2.818 -9.964)",
    fill: "#7d0000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1493",
    "data-name": "Caminho 1493",
    d: "M13.789,1.1H3.423A2.325,2.325,0,0,0,1.1,3.428V13.788a2.325,2.325,0,0,0,2.323,2.323H12.4a2.246,2.246,0,0,0,1.6-.662l1.455-1.455a2.246,2.246,0,0,0,.661-1.6V3.428A2.325,2.325,0,0,0,13.789,1.1ZM2.007,13.789V3.428A1.418,1.418,0,0,1,3.423,2.011H13.789A1.418,1.418,0,0,1,15.2,3.428v8.033H13.078a1.615,1.615,0,0,0-1.614,1.614V15.2H3.423a1.418,1.418,0,0,1-1.416-1.416Zm12.8-.435-1.454,1.454a1.347,1.347,0,0,1-.957.4h-.026v-2.13a.708.708,0,0,1,.706-.707H15.2v.03a1.345,1.345,0,0,1-.4.957Z",
    fill: "#7d0000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNota);
export default __webpack_public_path__ + "static/media/nota.ce7e05a57faa57913739f35e28249fa2.svg";
export { ForwardRef as ReactComponent };